<template>
  <div class="item-description">
    <div class="item-container">
      <a
        v-if="packageId"
        :href="packagePath"
        class="in-cart-package-link"
      >
        <p class="name"> {{ name }}</p>
      </a>
      <a
        v-else-if="hotelId"
        :href="hotelPath"
        class="in-cart-package-link"
      >
        <p class="name"> {{ name }}</p>
      </a>
      <p
        v-else
        class="name"
      >
        {{ name }}
      </p>
      <p
        v-if="isGPE()"
        class="event-name"
        :class="[ eventname == '' ? 'hide' : '' ]"
      >
        {{ eventlabel || eventname }}
      </p>
      <p
        v-else
        class="event-name"
        :class="[ eventname == '' ? 'hide' : '' ]"
      >
        {{ eventname }}
      </p>
      <p
        class="hotel-duration"
        :class="[ hasDate ? 'hide' : '' ]"
      >
        {{ reformatDates() }}
      </p>
    </div>
    <div class="price-container">
      <p class="price">
        {{ price }}
      </p>
      <p
        v-if="candelete == &quot;true&quot;"
        class="delete"
        @click="deleteOrderItem"
      />
      <p
        v-else
        class="delete"
        :class="[ hotelId == 0 && packageId == 0 ? 'hide' : '' ]"
        @click="deleteHotelItem"
      />
    </div>
    <div
      v-if="ers"
      class="errors"
    >
      <span>{{ ers }}</span>
      <span
        class="delete"
        @click="ers = null"
      />
    </div>
  </div>
</template>

<script>
/* global locale */
import Api from '../../cart_api'

export default {
  props: {
    candelete: {
      type: String,
      default: ''
    },
    checkIn: {
      type: String,
      default: '',
      required: false
    },
    checkOut: {
      type: String,
      default: '',
      required: false
    },
    contracted: {
      type: Boolean,
      default: null
    },
    eventname: {
      type: String,
      default: ''
    },
    eventlabel: {
      type: String,
      default: ''
    },
    hotelId:{
      type: Number,
      default: 0
    },
    itemid: {
      type: Number,
      default:0
    },
    name: {
      type: String,
      default:''
    },
    price: {
      type: String,
      default:''
    },
    packageId: {
      type: Number,
      default:0
    }
  },

  data() {
    return {
      ers: null,
      updating: false,
      chosenPackage:{},
      packagePath: `/${locale}/packages/${this.packageId}/path`,
      hotelPath: `/${locale}/cart/items/${this.itemid}/hotels`,
      dataName: '',
      dataPrice: null,
    }
  },

  computed: {
    hasDate() {
      if (this.checkIn == null || this.checkIn == '') {
        return true
      } else {
        return false
      }
    }
  },

  created(){
    this.setCart()
  },

  methods: {
    isGPE(){
      return window.brand_name=='Grand Prix Events'
    },
    reformatDates(){
      if(this.checkIn && this.checkOut) {
        let checkin = this.checkIn.split('/')
        let checkout = this.checkOut.split('/')
        let formattedCheckin = new Date(+checkin[2], checkin[1] - 1, +checkin[0]).toLocaleDateString(locale,
          { month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'UTC'})
        let formattedCheckout = new Date(+checkout[2], checkout[1] - 1, +checkout[0]).toLocaleDateString(locale,
          { month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'UTC'})
        return `${formattedCheckin} - ${formattedCheckout}`
      }
    },
    deleteOrderItem() {
      if (this.updating) { return }
      this.ers = null
      this.updating = true
      Api.changeOrderItem(this.itemid, 'DELETE', null).then(item => {
        if (item.errors) { this.ers = item.errors }
        this.updating = false
        if(document.getElementById('packageInCartDisplay')){
          document.getElementById('packageInCartDisplay').classList.add('hidden')
        }
      })
    },

    deleteHotelItem() {
      if (this.updating) { return }
      this.ers = null
      this.updating = true
      if(this.contracted == true) {
        Api.deleteContractedHotelItem(this.itemid, this.hotelid, 'DELETE', null).then(item => {
          if (item.errors) { this.ers = item.errors }
          this.updating = false
        })
      } else {
        Api.deleteH4hHotelItem(this.itemid, this.hotelid, 'DELETE', null).then(item => {
          if (item.errors) { this.ers = item.errors }
          this.updating = false
        })
      }
    },

    setCart(){
      Api.getOrder().then(order => {
        if(this.packageId){
          this.packageQty=order.item_count
          this.orderId=order.id
          this.orderItemId=this.itemid
        }
        else {
          this.setPackage(order)
        }
      })
    },

    setPackage(order){
      this.chosenPackage=order.items.find(orderItem=>{
        return orderItem.id==this.itemid
      })
    }
  }
}
</script>
